import React from "react";
import {
  CertificateIcon, ShieldCheck, MapPin, Lightning, Lock, Medal, HandHeart,
} from "@phosphor-icons/react";

// Phosphor renamed Certificate to CertificateIcon recently; fall back gracefully.
const SafeCertificate = CertificateIcon || ShieldCheck;

const BADGES = [
  { icon: SafeCertificate, label: "Microsoft Certified" },
  { icon: SafeCertificate, label: "CompTIA A+" },
  { icon: ShieldCheck,     label: "Fully Insured" },
  { icon: MapPin,          label: "Local NC Company" },
  { icon: Lightning,       label: "Same-Day Service" },
  { icon: Lock,            label: "Secure Remote Support" },
  { icon: Medal,           label: "Satisfaction Guarantee" },
  { icon: HandHeart,       label: "No-Fix-No-Fee" },
];

export default function TrustBadges() {
  return (
    <section data-testid="trust-badges-section" className="bg-white py-14 md:py-16 border-y border-zinc-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-xs font-semibold uppercase tracking-widest text-blue-600">Trusted by NC businesses & homes</div>
          <h3 className="mt-2 font-heading text-xl sm:text-2xl font-semibold text-zinc-900">
            Certified · Insured · Local · Guaranteed
          </h3>
        </div>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={b.label}
                data-testid={`trust-badge-${i}`}
                className="flex items-center gap-3 rounded-xl border border-zinc-200 bg-zinc-50 px-4 py-3.5 hover:border-blue-300 hover:bg-white transition-all"
              >
                <div className="h-9 w-9 shrink-0 rounded-lg bg-blue-600/10 text-blue-600 grid place-items-center">
                  <Icon size={18} weight="duotone" />
                </div>
                <span className="text-sm font-semibold text-zinc-800">{b.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
